import { FC } from 'react'

import { SocialNetwork } from 'models'
import { IconTelegram } from 'components/icons/telegram'
import { IconFacebook } from 'components/icons/facebook'
import { IconTwitter } from 'components/icons/twitter'
import { IconWhatsapp } from 'components/icons/whatsapp'
import { IconYoutube } from 'components/icons/youtube'
import { IconInstagram } from 'components/icons/instagram'
import { Container } from 'components/container'
import { useDataContext } from 'context/data-context'
import {
  About,
  Authors,
  Copyright,
  Heading,
  Social,
  SocialLinks,
  StyledFooter,
} from './styled'

type Props = {}

const socialConfig = {
  facebook: {
    icon: <IconFacebook />,
    link: 'https://www.facebook.com/azattyk.org',
    newTab: true,
  },
  twitter: {
    icon: <IconTwitter />,
    link: 'https://x.com/Azattyk_Radiosu',
    newTab: true,
  },
  instagram: {
    icon: <IconInstagram />,
    link: 'https://www.instagram.com/azattyk.kg/',
    newTab: true,
  },
  telegram: {
    icon: <IconTelegram />,
    link: 'https://telegram.me/Azattyk_radiosu',
    newTab: true,
  },
  youtube: {
    icon: <IconYoutube />,
    link: 'https://www.youtube.com/user/AzattykUnalgysy',
    newTab: true,
  },
  whatsapp: {
    icon: <IconWhatsapp />,
    link: 'https://www.whatsapp.com/channel/0029VaEfXksHbFV2MNnL1I3E',
    newTab: true,
  },
}

const parseSocial = () => (
  <SocialLinks>
    {(Object.keys(socialConfig) as SocialNetwork[]).map((k) => {
      const networkConfig = socialConfig[k]

      return networkConfig ? (
        <li key={k}>
          <a
            href={networkConfig.link}
            {...(networkConfig.newTab ? { target: '_blank' } : null)}
          >
            {networkConfig.icon}
          </a>
        </li>
      ) : null
    })}
  </SocialLinks>
)

export const Footer: FC<Props> = () => {
  const { translate } = useDataContext()

  return (
    <StyledFooter>
      <Container>
        <Authors>
          <Heading>{translate('Authors of the project title')}</Heading>

          <p>
            <strong>Автор:</strong> «Азаттык» радиосу
            <br />
            <strong>Дизайн:</strong> Pangea Digital Dataviz тобу
          </p>
        </Authors>
        <Social>
          <Heading>{translate('Follow us')}</Heading>
          {parseSocial()}
        </Social>
        <About>
          <Heading>{translate('About the radio title')}</Heading>
          <p>{translate('About the radio description')}</p>
        </About>
        <Copyright>
          &copy; {new Date().getFullYear()} {translate('Copyright text')}
        </Copyright>
      </Container>
    </StyledFooter>
  )
}
